import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseDto } from "@models/base/baseDto.model";
import { ResultadoProcesoResumenMasivoInquilinosDto } from "@models/resultadoResumenInquilinoEnvioCorreo/resultadoProcesoResumenMasivoInquilinosDto.model";
import { ResultadoResumenInquilinoEnvioCorreoDto } from "@models/resultadoResumenInquilinoEnvioCorreo/resultadoResumenInquilinoEnvioCorreoDto.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ResultadoResumenInquilinoEnvioCorreoService {

  private resultadoProcesoResumenMasivoInquilinosDto!: ResultadoProcesoResumenMasivoInquilinosDto;
  constructor(
    private http: HttpClient
  ) { }

  setResultadoProcesoResumenMasivoInquilinosDto(data: ResultadoProcesoResumenMasivoInquilinosDto) {
    this.resultadoProcesoResumenMasivoInquilinosDto = data;
  }

  getResultadoProcesoResumenMasivoInquilinosDto() {
    return this.resultadoProcesoResumenMasivoInquilinosDto;
  }

  getAllByIdContrato(idContrato: number): Observable<ResultadoResumenInquilinoEnvioCorreoDto[]> {
    return this.http.get<ResultadoResumenInquilinoEnvioCorreoDto[]>("/api/ResultadoResumenInquilinoEnvioCorreo/GetAllByIdContrato?idContrato=" + idContrato);
  }

  getAllByIdProcesoMasivo(idProcesoMasivo: string): Observable<ResultadoResumenInquilinoEnvioCorreoDto[]> {
    return this.http.get<ResultadoResumenInquilinoEnvioCorreoDto[]>("/api/ResultadoResumenInquilinoEnvioCorreo/GetAllByIdProcesoMasivo?idProcesoMasivo=" + idProcesoMasivo);
  }

  getAllResumenByIdProcesoMasivo(idProcesoMasivo: string): Observable<ResultadoProcesoResumenMasivoInquilinosDto> {
    return this.http.get<ResultadoProcesoResumenMasivoInquilinosDto>("/api/ResultadoResumenInquilinoEnvioCorreo/GetAllResumenByIdProcesoMasivo?idProcesoMasivo=" + idProcesoMasivo);
  }

  getResumenAgrupadoPorProceso(): Observable<string[]> {
    return this.http.get<string[]>("/api/ResultadoResumenInquilinoEnvioCorreo/GetResumenAgrupadoPorProceso");
  }
}
